// extracted by mini-css-extract-plugin
export default {"gifContainer":"VoiceSearch_gifContainer__P8ksH","note":"VoiceSearch_note__jNYZU"};